import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { VideoAlbumService } from 'src/app/shared/API-Service/services/video-album.service';
import { PhotoService } from 'src/app/shared/API-Service/services/photo.service';
import { GovernorateService } from 'src/app/shared/API-Service/services/governorate.service';


@Component({
  selector: 'app-insert-video-album',
  templateUrl: './insert-video-album.component.html',
  styleUrls: ['./insert-video-album.component.css']
})
export class InsertVideoAlbumComponent implements OnInit {
  recordtoupdate: any;
  videoalbumForm:FormGroup;
  videoFormdata:FormData;
  update:boolean = false;
  button:boolean = false;
  Image: File;
imageLogo: string;
img : string = Image;
selectedItemsGovernates:any[]=[];
Governates:any;
dropdownSettings: any = {};
  constructor(private GovernorateService:GovernorateService,private _VideoAlbumService:VideoAlbumService,private _Router:Router,private _FormBuilder:FormBuilder) { 
    this.imageLogo="../../../../../assets/images/upload.png"

  }

  ngOnInit(): void {
    this.initiate();
    this.checkEdit();
    this.GetGovernorate();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'titleAr',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
     
  };
  }
  GetGovernorate(){
    this.GovernorateService.GetGovernorate().subscribe(res=>{
      this.Governates=res.data;
    })
  }
  initiate(){
    this.videoalbumForm = this._FormBuilder.group({
      title: [''],
      titleAr: ['', Validators.required],
     videoalbumImage:['', Validators.required],
     order:['', Validators.required],
     GovernatesIds:['',Validators.required]
    
    });
  }
  insertappenddata(){
    this.videoFormdata = new FormData();
    this.videoFormdata.append("Title", this.videoalbumForm.value.title);
    this.videoFormdata.append("TitleAr", this.videoalbumForm.value.titleAr);
    this.videoFormdata.append("VideoAlbumImage", this.Image);
    this.videoFormdata.append("Order", this.videoalbumForm.value.order);
    this.selectedItemsGovernates.forEach(element => {
      this.videoFormdata.append("GovernoratesIds", element.id);  
    });
   
  }
  updateappenddata(){
    this.videoFormdata = new FormData();
    this.videoFormdata.append("Id", this.recordtoupdate.id);
    this.videoFormdata.append("Title", this.videoalbumForm.value.title);
    this.videoFormdata.append("TitleAr", this.videoalbumForm.value.titleAr);
    this.videoFormdata.append("VideoAlbumImage", this.Image);
    this.videoFormdata.append("Order", this.videoalbumForm.value.order);
    this.selectedItemsGovernates.forEach(element => {
      this.videoFormdata.append("GovernoratesIds", element.id);  
    });
   
  }
  checkEdit() {
    this._VideoAlbumService.Data.subscribe((res) => {
      if (res != null) {
        this.videoalbumForm = this._FormBuilder.group({
          title: [res.title],
          titleAr: [res.titleAr, Validators.required],
          order: [res.order, Validators.required], 
          videoalbumImage : [res.image],
          GovernatesIds:['',Validators.required]
        });
        this.imageLogo = this.img + res.image;
        this.selectedItemsGovernates=res.governorates;
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
        // this.initiate();
      }
     
    });
  }
   // imgFile
   getLogoUrl(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.Image = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageLogo = reader.result as string;
        // this.logoForm?.append("image", this.Image);
        this.videoalbumForm.get("videoalbumImage").setValue(this.Image);

      };
    }
  }
  get fc() {
    return this.videoalbumForm.controls;
  }
  onSubmit(){
    this.button = true;
   if(this.update == false && this.videoalbumForm.status == "VALID"){
    this.insertappenddata()
    this._VideoAlbumService.CreateVideoAlbum(this.videoFormdata).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.videoalbumForm.reset();
      this._Router.navigate(['/content/admin/ViewVideoAlbum']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.error.message    
      }) 
      this.button = false ;
    }, () => {
    })
   } else if(this.videoalbumForm.status == "VALID"){
     this.updateappenddata()
    this._VideoAlbumService.UpdateVideoAlbum(this.videoFormdata).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.videoalbumForm.reset();
      this._Router.navigate(['/content/admin/ViewVideoAlbum']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.error.message    
      }) 
    }, () => {
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.videoalbumForm.markAllAsTouched();
    this.button = false;
   }
  }
  ngOnDestroy(){
    this._VideoAlbumService.Data.next(null);
     }
}
